
import React, { useEffect,useContext,useRef  } from "react";
import { useLocation, } from 'react-router-dom';
import Context from '../context/context';
import helpersFunction from "../_helpers/helpersFunction";
const config = require("../_helpers/configServizi"); 

const useLocationChange = (action) => {
    const location = useLocation()
    const  context = useContext(Context)
    const firstUpdate = useRef(true);
    const domain = window.location.hostname;

    useEffect(() => { 
       
    
        if(location.pathname === "/"){
            console.log("location",location.pathname)
            if(config.servizi[domain].one_trust ){
                helpersFunction.addExternalScriptToComponent(config.servizi[domain].one_trust.url,firstUpdate,config.servizi[domain].one_trust.data_attribute)
            }
        }
        
        
    }, [location])

    return <></>
}


export default useLocationChange;